import operatorApiService from "../services/operator-api.service";

export async function setPlayoutDelay(
  remoteFeeds: Record<string, any>,
  suids: Record<string, string>,
  sdkServerUserInfo: any
): Promise<void> {
  for (const id of Object.keys(remoteFeeds)) {
    const suid = suids[id];
    if (!suid) return;

    try {
      const response = await operatorApiService.doPostTransmitterCurrentStatus({
        baseId: sdkServerUserInfo.baseId,
        suid,
      });
      const delayInfo = response.data?.target_delay;

      if (!delayInfo || delayInfo.delay_ms == null) {
        console.warn("delayInfo 不正な形式:", delayInfo, "response:", response);
        continue;
      }

      const config = remoteFeeds[id]?.webrtcStuff;
      if (!config?.pc) {
        console.error("Invalid PeerConnection");
      }

      const receivers = config.pc.getReceivers();
      const delay = delayInfo.delay_ms / 1000;

      receivers.forEach((receiver: RTCRtpReceiver) => {
        try {
          (receiver as any).playoutDelayHint = delay;
          console.log(`SUID:${suid}  playoutDelayHint: ${delay}`);
        } catch (e) {
          console.warn("playoutDelayHint 設定失敗", e);
        }
      });
    } catch (err: any) {
      if (err?.response?.status && err.response.status !== 404) {
        console.log("***DEBUG** XMLHttpRequest : " + err.response.status);
      }
      console.log("***DEBUG** error : " + (err?.message ?? err));
    }
  }
}
